import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

export const Root = styled("div")(({ theme }) => ({
  paddingTop: 16,
  paddingBottom: 35,
  overflow: "hidden",
  [theme.breakpoints.up("mobile")]: {
    paddingTop: 40,
  },
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  marginBottom: 8,
  [theme.breakpoints.up("tablet")]: {
    textAlign: "left",
    marginBottom: 28,
  },
}));
